module.exports = __webpack_public_path__ + "img/aeroland-tab-content-image-01.b20ceb5f.jpg";